import React, { useEffect, useState } from "react";
import styles from "./ingPg.module.css";

const IngPg = (props) => {
  return (
    <div className={styles.ingPgCont}>
      <img
        className={styles.loading}
        src="../images/icons/loading.png"
        alt="로딩중 이미지"
        width="auto"
        height="150px"
      />
      <div className={styles.ingTextCont}>
        <p className={styles.ingTitle}>
          <b>홈페이지 준비중</b>입니다.
        </p>
        <p className={styles.ingSubTitle}>현재 홈페이지 준비중입니다.</p>
        <p className={styles.ingSubTitle}>
          빠른 시일 내에 준비하여 찾아뵙겠습니다.
        </p>
      </div>
      <div className={styles.imgCont}>
        <img
          className={styles.ingLogo}
          src="../images/logos/erum_logo_horizontal_black.png"
          alt="이룸손해사정 로고"
          width="250px"
          loading="lazy"
          decoding="async"
        />
        <p>대표번호: 02-952-0635</p>
        <p>팩스번호: 02-952-0639</p>
        <p>EMAIL: erum-korea@naver.com</p>
      </div>
    </div>
  );
};

export default IngPg;
